module.exports = __webpack_public_path__ + "img/member_coupons_icon_ycq.44971343.png";